/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateRecordingEnvelopePayloadContributionsInner } from './CreateRecordingEnvelopePayloadContributionsInner';
import {
    CreateRecordingEnvelopePayloadContributionsInnerFromJSON,
    CreateRecordingEnvelopePayloadContributionsInnerFromJSONTyped,
    CreateRecordingEnvelopePayloadContributionsInnerToJSON,
} from './CreateRecordingEnvelopePayloadContributionsInner';
import type { LookupRecordingResponseExistingArtistsInner } from './LookupRecordingResponseExistingArtistsInner';
import {
    LookupRecordingResponseExistingArtistsInnerFromJSON,
    LookupRecordingResponseExistingArtistsInnerFromJSONTyped,
    LookupRecordingResponseExistingArtistsInnerToJSON,
} from './LookupRecordingResponseExistingArtistsInner';
import type { LookupRecordingResponseExistingRecording } from './LookupRecordingResponseExistingRecording';
import {
    LookupRecordingResponseExistingRecordingFromJSON,
    LookupRecordingResponseExistingRecordingFromJSONTyped,
    LookupRecordingResponseExistingRecordingToJSON,
} from './LookupRecordingResponseExistingRecording';
import type { LookupRecordingResponseExistingRelease } from './LookupRecordingResponseExistingRelease';
import {
    LookupRecordingResponseExistingReleaseFromJSON,
    LookupRecordingResponseExistingReleaseFromJSONTyped,
    LookupRecordingResponseExistingReleaseToJSON,
} from './LookupRecordingResponseExistingRelease';

/**
 * 
 * @export
 * @interface CreateRecordingEnvelopePayload
 */
export interface CreateRecordingEnvelopePayload {
    /**
     * 
     * @type {LookupRecordingResponseExistingRecording}
     * @memberof CreateRecordingEnvelopePayload
     */
    recording?: LookupRecordingResponseExistingRecording;
    /**
     * The add arm (4.1.4.2g): the WMC id of a Recording that already exists, from the existence lookup. Mutually exclusive with `recording`; forbids `artists` and `release`.
     * @type {string}
     * @memberof CreateRecordingEnvelopePayload
     */
    existingRecordingId?: string;
    /**
     * 
     * @type {Array<LookupRecordingResponseExistingArtistsInner>}
     * @memberof CreateRecordingEnvelopePayload
     */
    artists?: Array<LookupRecordingResponseExistingArtistsInner>;
    /**
     * 
     * @type {Array<CreateRecordingEnvelopePayloadContributionsInner>}
     * @memberof CreateRecordingEnvelopePayload
     */
    contributions?: Array<CreateRecordingEnvelopePayloadContributionsInner>;
    /**
     * 
     * @type {LookupRecordingResponseExistingRelease}
     * @memberof CreateRecordingEnvelopePayload
     */
    release?: LookupRecordingResponseExistingRelease | null;
}

/**
 * Check if a given object implements the CreateRecordingEnvelopePayload interface.
 */
export function instanceOfCreateRecordingEnvelopePayload(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateRecordingEnvelopePayloadFromJSON(json: any): CreateRecordingEnvelopePayload {
    return CreateRecordingEnvelopePayloadFromJSONTyped(json, false);
}

export function CreateRecordingEnvelopePayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateRecordingEnvelopePayload {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'recording': !exists(json, 'recording') ? undefined : LookupRecordingResponseExistingRecordingFromJSON(json['recording']),
        'existingRecordingId': !exists(json, 'existing_recording_id') ? undefined : json['existing_recording_id'],
        'artists': !exists(json, 'artists') ? undefined : ((json['artists'] as Array<any>).map(LookupRecordingResponseExistingArtistsInnerFromJSON)),
        'contributions': !exists(json, 'contributions') ? undefined : ((json['contributions'] as Array<any>).map(CreateRecordingEnvelopePayloadContributionsInnerFromJSON)),
        'release': !exists(json, 'release') ? undefined : LookupRecordingResponseExistingReleaseFromJSON(json['release']),
    };
}

export function CreateRecordingEnvelopePayloadToJSON(value?: CreateRecordingEnvelopePayload | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'recording': LookupRecordingResponseExistingRecordingToJSON(value.recording),
        'existing_recording_id': value.existingRecordingId,
        'artists': value.artists === undefined ? undefined : ((value.artists as Array<any>).map(LookupRecordingResponseExistingArtistsInnerToJSON)),
        'contributions': value.contributions === undefined ? undefined : ((value.contributions as Array<any>).map(CreateRecordingEnvelopePayloadContributionsInnerToJSON)),
        'release': LookupRecordingResponseExistingReleaseToJSON(value.release),
    };
}

